import { CAT_PRODUCT_ORDERS } from 'App/utils/Collections';
import { FT_DATE, FT_CHECKBOX, FT_LIST, FT_AUTOCOMPLETE, FT_SINGLE } from '../FilterTypes';

import {
  statusItemsLoader,
  // searchStatusItems,
  loadLocations,
  searchCourierDeliveryServices,
  searchCustomers,
  searchProjects,
} from './loaders';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  tracking: {
    name: 'Tracking',
    groupOrderIndex: 1,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 2,
  },
};

export default {
  category: CAT_PRODUCT_ORDERS,
  filters: [
    {
      id: 'dealItems.item.wimsId',
      label: 'Product ID',
      type: FT_SINGLE,
      group: groups.general,
    },
    {
      id: 'dealItems.item.name',
      label: 'Product name',
      type: FT_SINGLE,
      group: groups.general,
    },
    {
      id: 'project.id',
      label: 'Project',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: searchProjects,
      },
    },
    {
      id: 'status.id',
      label: 'Status',
      type: FT_LIST,
      group: groups.general,
      getListItems: () => statusItemsLoader(1),
    },
    {
      id: 'customer.id',
      label: 'Customer',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: searchCustomers,
      },
    },
    {
      id: 'urgent',
      label: 'Urgent',
      fieldConf: {
        label: 'Urgent delivery',
      },
      group: groups.tracking,
      type: FT_CHECKBOX,
      defaultValue: () => false,
    },
    {
      id: 'createdAt',
      label: 'Created at',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'updatedAt',
      label: 'Updated at',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'trackingParcels.countryOfDeparture.id',
      label: 'Departure country',
      type: FT_AUTOCOMPLETE,
      group: groups.tracking,
      fieldConf: {
        searcher: loadLocations,
      },
    },
    {
      id: 'trackingParcels.countryOfDestination.id',
      label: 'Destination country',
      type: FT_AUTOCOMPLETE,
      group: groups.tracking,
      fieldConf: {
        searcher: loadLocations,
      },
    },
    {
      id: 'trackingParcels.courierDeliveryService.id',
      label: 'Delivery services',
      type: FT_AUTOCOMPLETE,
      group: groups.tracking,
      fieldConf: {
        searcher: searchCourierDeliveryServices,
      },
    },
  ],
  searchBarProp: 'complex_name',
};
